import React, { useRef, useState, useEffect } from 'react';

const HomePage = () => {
  const [hoursSinceBirth, setHoursSinceBirth] = useState(0);

  // Calculate hours since December 6, 1974 at 12:34
  useEffect(() => {
    const calculateHours = () => {
      const birthDate = new Date('1974-12-06T12:34:56');
      const now = new Date();
      const diffInMilliseconds = now - birthDate;
      const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
      setHoursSinceBirth(diffInHours);
    };

    // Calculate immediately
    calculateHours();

    // Update every hour
    const interval = setInterval(calculateHours, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // Split number into individual digits for flip counter effect
  const formatNumberForCounter = (num) => {
    const numStr = num.toLocaleString().replace(/,/g, '');
    return numStr.split('').map((digit, index) => ({
      current: digit,
      next: digit === '9' ? '0' : String(parseInt(digit) + 1),
      key: `${index}-${digit}`
    }));
  };

  return (
      <div className="page-container-wrapper max-width-default padding-default">
        <div className="page-header">
          <h1>
            <i className="fas fa-home"></i>
            Hello
          </h1>
          <p>Welcome to my site! I'm Marco De Marco, and I'm excited to have you here.<br></br>
          This site is a celebration of family, heritage, and the things that matter most to me, that I would like to share with you.</p>
        </div>
        
        <div className="page-content">
          <div className="section">
            <p>
From my Italian roots with my tree spanning over 150 years, to my home in Southington, Connecticut, to the simple pleasures of good food, wine, and family traditions - this site tells my story.<br></br>
Whether you're here to explore my family history, learn about town, or discover some authentic Italian recipes, I hope you find something that connects with you.
            </p>            
                   {/* Mechanical Flip Counter */}
      <div className="click-counter">
        <div className="counter-display">
          <div className="flip-counter">
            {formatNumberForCounter(hoursSinceBirth).map((digit, index) => (
              <div key={digit.key} className="digit-wheel">
                <div className="digit-current">{digit.current}</div>
                <div className="digit-next">{digit.next}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
          </div>
        </div>
      </div>
  );
};

export default HomePage;